"use client";

import { LoadingOverlay } from "@mantine/core";
import { Suspense, useEffect, useRef } from "react";

import { ScreenersTable } from "@/components/table/views/screeners";
import { useUserContext } from "@/context/user.context";
import { useTrackAnalytics } from "@/hooks/analytics.hooks";

const ActiveScreenersPage = () => {
  const userTrackedRef = useRef(false);
  const track = useTrackAnalytics();
  const { user } = useUserContext();

  useEffect(() => {
    if (!userTrackedRef.current && user) {
      userTrackedRef.current = true;
      track("Screener Admin Home Viewed");
    }
  }, [track, user]);

  return (
    <Suspense fallback={<LoadingOverlay visible />}>
      <ScreenersTable />
    </Suspense>
  );
};

export default ActiveScreenersPage;
